import script from "./saleDaily.vue?vue&type=script&setup=true&lang=js"
export * from "./saleDaily.vue?vue&type=script&setup=true&lang=js"

import "./saleDaily.vue?vue&type=style&index=0&id=a06947ba&lang=less"

const __exports__ = script;

export default __exports__